import { render, staticRenderFns } from "./AdminServicePoints.vue?vue&type=template&id=357419b6&scoped=true"
import script from "./AdminServicePoints.vue?vue&type=script&lang=js"
export * from "./AdminServicePoints.vue?vue&type=script&lang=js"
import style0 from "./AdminServicePoints.vue?vue&type=style&index=0&id=357419b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357419b6",
  null
  
)

export default component.exports